import {useTranslation} from "react-i18next"
import {useHistory} from "react-router-dom"
import {Spin} from "antd"
import cx from "classnames"
import {BaseButton, SecondaryButton} from "components/buttons"
import {useModel} from "hooks"
import styles from "./TaskProcessing.module.css"

type Props = {
    isTimedOut?: boolean
    isAlreadyProcessing?: boolean
    compact?: boolean
    onRefresh?: () => void
}

export function TaskProcessing({isTimedOut, isAlreadyProcessing, compact, onRefresh}: Props) {
    const {t} = useTranslation(["tasks"])
    const model = useModel()
    const history = useHistory()

    const getMessage = () => {
        if (isTimedOut) {
            return t("tasks.stillProcessing")
        }
        return isAlreadyProcessing ? t("tasks.alreadyProcessing") : t("tasks.generatingDocument")
    }

    return (
        <div className={cx(styles.wrap, {[styles.wrap__compact]: compact})}>
            {!isTimedOut && <Spin size={compact ? "default" : "large"} />}
            <p className={styles.text}>{getMessage()}</p>
            <div className={styles.actions}>
                {isTimedOut && onRefresh && <BaseButton title={t("tasks.refresh")} onClick={onRefresh} />}
                {!compact && !model.isSubmittingTaskFromEmail && (
                    <SecondaryButton title={t("tasks.backToMyTasks")} onClick={() => history.push("/tasks")} />
                )}
            </div>
        </div>
    )
}
